import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import ReactApexCharts from "react-apexcharts";
import DateFns from "date-fns";
import {
  Container,
  FormControl,
  ListItemText,
  Typography,
  Stepper,
  Step,
  Input,
  InputLabel,
  StepLabel,
  Grid,
  MenuList,
  MenuItem,
  FormHelperText,
  Checkbox,
  TextField,
  Divider,
  Select,
  Menu,
} from "@material-ui/core";
import CustomTabs from "components/CustomTabs/CustomTabs";
// import EChartsAreaChart from "../../views/AnalyticsEchart";
import {
  LargeAreaChart,
  WaterfallChart,
  Heatmap,
  ResponsiveBarChart,
} from "../../views/GlAnalytics/AnalyticsEchart";
import OfflineBoltIcon from "@material-ui/icons/OfflineBolt";
import SignalCellularAltIcon from "@material-ui/icons/SignalCellularAlt";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Card from "../../components/Card/Card.js";
import CardBody from "../../components/Card/CardBody";
import SwitchSelector from "react-switch-selector";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
}));

function BuildingDropDown() {
  const buildingName = localStorage.getItem("buildingName");
  const BuildingOptions =
    buildingName && buildingName.length > 0
      ? buildingName.split(",").map((name) => ({ name }))
      : [];

  const [selectedBuilding, setSelectedBuilding] = useState(
    BuildingOptions.length > 0 ? BuildingOptions[0] : null
  );
  return (
    <div>
      <Autocomplete
        id="building-combo-box"
        options={BuildingOptions}
        style={{ width: "100%", height: "100%" }}
        getOptionLabel={(option) => option.name}
        value={selectedBuilding}
        renderInput={(params) => (
          <TextField
            {...params}
            style={{ height: "100%" }}
            label="Select a Building"
            variant="outlined"
            fullWidth
            InputProps={{
              ...params.InputProps,
              style: { height: "5vh", display: "flex", alignItems: "center" },
            }}
          />
        )}
      />
    </div>
  );
}

function FloorDropDown({ Name, onFloorChange }) {
  const floorOptions = Name.map((floor) => ({
    name: floor.name,
    rooms: Object.keys(floor.data).flatMap((room) =>
      Object.keys(floor.data[room])
    ),
  })).sort((a, b) => a.name.localeCompare(b.name));

  const allFloorsOption = { name: "ALL Floors", rooms: [] };
  const optionsWithAll = [allFloorsOption, ...floorOptions];
  const [selectedFloor, setSelectedFloor] = useState(optionsWithAll[0]);

  useEffect(() => {
    onFloorChange(selectedFloor);
  }, [selectedFloor, onFloorChange]);

  return (
    <div>
      <Autocomplete
        id="floor-combo-box"
        options={optionsWithAll}
        style={{ width: "100%", height: "100%" }}
        getOptionLabel={(option) => option.name}
        value={selectedFloor}
        onChange={(event, newValue) => {
          setSelectedFloor(newValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            style={{ height: "100%" }}
            label="Select a Floor"
            variant="outlined"
            fullWidth
            InputProps={{
              ...params.InputProps,
              style: { height: "5vh", display: "flex", alignItems: "center" },
            }}
          />
        )}
      />
    </div>
  );
}

const getCardStyle = () => ({
  background: "#FFFFFF 0% 0% no-repeat padding-box",
  textAlign: "center",
  borderRadius: "6px",
  boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
  backgroundColor: "#fcfafa",
  height: "5vh",
  marginTop: "1vh",
  opacity: "1",
});

const getConsumptionCard = () => ({
  background: "#FFFFFF 0% 0% no-repeat padding-box",
  textAlign: "center",
  borderRadius: "6px",
  boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
  backgroundColor: "#fcfafa",
  height: "33vh",
  marginTop: "-4vh",
  opacity: "1",
});

const getCardStyleMulitpleCards = () => ({
  background: "#FFFFFF 0% 0% no-repeat padding-box",
  textAlign: "center",
  borderRadius: "6px",
  boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
  backgroundColor: "#fcfafa",
  height: "12vh",
  marginTop: "-4vh",
  opacity: "1",
});

const options = [
  {
    selectedFontColor: "white",
    label: "Daily",
    value: 0,
    selectedBackgroundColor: "#0123B4",
  },
  {
    selectedFontColor: "white",
    label: "Weekly",
    value: 1,
    selectedBackgroundColor: "#0123B4",
  },
  {
    selectedFontColor: "white",
    label: "Monthly",
    value: 2,
    selectedBackgroundColor: "#0123B4",
  },
];

// const cardData = [
//   { label: "Energy Consumption", valueKey: "EnergyConsumption", unit: "kWh" },
// ];

function Analytics_Layout() {
  const classes = useStyles();
  const buildingID = localStorage.getItem("buildingID");
  const [floorName, SetFloorName] = React.useState([]);
  const [valueIndex, setValueIndex] = useState(0);
  const [timeRange, setTimeRange] = useState("Daily");
  const [energyData, setEnergyData] = useState({});
  const [peakDemand, setPeakDemand] = useState({});
  const [loadFactor, setLoadFactor] = useState({});

  const [lastSelectedFloor, setLastSelectedFloor] = useState(null); // Track the last selected floor
  const handleSwitchChange = (newValue) => {
    const timeRangeMap = {
      0: "Daily",
      1: "Weekly",
      2: "Monthly",
    };

    setValueIndex(newValue);
    setTimeRange(timeRangeMap[newValue]);
  };

//   useEffect(() => {
//     const fetchTree = async () => {
//       try {
//         const res = await api.analytics.getTreeStructure(buildingID);
//         const floorData = res?.data || res || {};
//         const FloorSelection = Object.keys(floorData).map((key) => ({
//           name: key,
//           data: floorData[key],
//         }));
//         SetFloorName(FloorSelection);
//       } catch (error) {
//         console.error("Failed to fetch Tree:", error);
//       }
//     };
//     fetchTree();
//   }, []);

//   const handleFloorChange = (floor) => {
//     if (lastSelectedFloor !== floor.name) {
//       console.log("Selected Floor:", floor.name);
//       setLastSelectedFloor(floor.name);
//       if (floor.name === "ALL Floors") {
//         api.analytics.getDeviceDataUsingBuilding("ALL").then((res) => {
//           setEnergyData(res.EnergyConsumption);
//           setPeakDemand(res.PeakDemand);
//           setLoadFactor(res.LoadFactor);
//         });
//       } else {
//         api.analytics
//           .getDeviceDataUsingBuilding(floor.name)
//           .then((res) => {
//             const floorKey = Object.keys(res)[0];
//             const floorData = res[floorKey];
//             console.log("floorData", floorData);
//             if (floorData) {
//               setEnergyData(floorData.EnergyConsumption);
//               setPeakDemand(floorData.PeakDemand);
//               setLoadFactor(floorData.LoadFactor);
//             } else {
//               console.warn(`No data found for floor key ${floorKey}`);
//               setEnergyData({});
//               setPeakDemand({});
//               setLoadFactor({});
//             }
//           })
//           .catch((error) => {
//             console.error(
//               `Error fetching data for floor ${floor.name}:`,
//               error
//             );
//             setEnergyData({});
//             setPeakDemand({});
//             setLoadFactor({});
//           });
//       }
//     }
//   };

  const cardData = () => {
    return [
      {
        label: "Energy Consumption",
        // value: Number(energyData?.[timeRange] || 0),
        value:19387,
        unit: "KWh",
        // icon: <OfflineBoltIcon style={{ fontSize: 40 }} />,
      },
      {
        label: "Peak Demand",
        // value: Number(peakDemand?.[timeRange] || 0),
         value:898,
        unit: "KWh",
        // icon: <SignalCellularAltIcon style={{ fontSize: 40 }} />,
      },
      {
        label: "Load Factor",
        // value: Number(loadFactor?.[timeRange] || 0),
         value:0.97,
        unit: "KWh",
      },
      {
        label: "Asset Health Index",
         value:"N/A",
        // value: "N/A", // You can add separate API call or data source for this
        // unit: "%",
      },
      {
        label: "Comfort Index",
         value:"N/A",
        // value: "N/A", // You can add separate API call or data source for this
        // unit: "score",
      },
    ];
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid container item xs={12} spacing={1}>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
          
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
            
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}></Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
            <Card style={getCardStyle()}>
              <div
                className="your-required-wrapper"
                style={{ width: "40vh", marginLeft: "0vh", height: "5.0vh" }}
              >
                <SwitchSelector
                  options={options}
                  backgroundColor={"rgba(0, 0, 0, 0.04)"}
                  fontColor={"#000"}
                  selectedFontColor={"#000"}
                  optionBorderRadius={5}
                  wrapperBorderRadius={8}
                  fontSize={13}
                  onChange={handleSwitchChange}
                  initialSelectedIndex={valueIndex}
                />
              </div>
            </Card>
          </Grid>
        </Grid>
      <Grid container item xs={12} spacing={1}>
  {cardData().map((item, index) => {
    return (
      <Grid
        item
        key={index}
        style={{ marginLeft: "0vh", flexBasis: "20%" }}
      >
        <Card style={getCardStyleMulitpleCards()}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              textAlign: "center",
            }}
          >
            {item.icon && (
              <div style={{ marginBottom: "0.5vh" }}>
                {React.cloneElement(item.icon, { style: { fontSize: 30 } })}
              </div>
            )}
            <p
              style={{
                margin: 6,
                fontWeight: "bold",
                fontSize: 15,
                whiteSpace: "nowrap",
              }}
            >
              {item.label}
            </p>
            <p
              style={{
                margin: 0,
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              {item.value} {item.unit}
            </p>
          </div>
        </Card>
      </Grid>
    );
  })}
</Grid>

        <Grid container item xs={12} spacing={1}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
            <Card style={getConsumptionCard()}>{LargeAreaChart()}</Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
            <Card style={getConsumptionCard()}>{WaterfallChart()}</Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
            <Card style={getConsumptionCard()}>{Heatmap()}</Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
            <Card style={getConsumptionCard()}>{ResponsiveBarChart()}</Card>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default Analytics_Layout;
